import { Injectable } from '@angular/core';
import { AutoAttendantButtonAction, VoiceAppViewEntityType } from '../shared/models/generated/ziroModels';
import { ZiroIcons } from '../shared/models/ziro-icons.enum';
import { UiDialButton } from './teams-auto-attendant-edit-form/call-flows/auto-attendants-menu-buttons/teams-auto-attendants-menu-buttons.component';
import { ZiroSelectOption } from '../forms/fields/select/ziro-select.component';

export interface UiDialButtonDisplay {
  label: string;
  destination: string;
  icon: string;
  subLabel?: string;
}

@Injectable({ providedIn: 'root' })
export class TeamsAutoAttendantsService {
  resolveButtonDisplay(btn: UiDialButton): UiDialButtonDisplay {
    switch (btn.action) {
      case AutoAttendantButtonAction.OPERATOR:
        return {
          label: 'tkey;admin.teams_voice_management.teams_auto_attendant.call_flow.button.transfer_to_operator',
          destination: '',
          icon: ZiroIcons.OPERATOR,
        };
      case AutoAttendantButtonAction.USER:
        return {
          label: 'tkey;admin.teams_voice_management.teams_auto_attendant.call_flow.button.transfer_to_user',
          destination: btn.entity?.displayName ?? '',
          icon: ZiroIcons.USER_OUTLINE,
        };
      case AutoAttendantButtonAction.VOICE_APP:
        return {
          label: 'tkey;admin.teams_voice_management.teams_auto_attendant.call_flow.button.transfer_to_voice_app',
          destination: btn.entity?.displayName ?? '',
          icon:
            btn.entity?.type === VoiceAppViewEntityType.AUTO_ATTENDANT
              ? ZiroIcons.AUTO_ATTENDANT
              : ZiroIcons.CALL_QUEUE,
        };
      case AutoAttendantButtonAction.RESOURCE_ACCOUNT:
        return {
          label: 'tkey;admin.teams_voice_management.teams_auto_attendant.call_flow.button.transfer_to_resource_account',
          destination: btn.entity?.displayName ?? '',
          icon: ZiroIcons.PHONE_LIST,
        };
      case AutoAttendantButtonAction.VOICEMAIL:
        return {
          label: 'tkey;admin.teams_voice_management.teams_auto_attendant.call_flow.button.transfer_to_voicemail',
          destination: btn.entity?.displayName ?? '',
          icon: ZiroIcons.VOICEMAIL_OUTLINE,
        };
      case AutoAttendantButtonAction.EXTERNAL_PHONE_NUMBER:
        return {
          label: 'tkey;admin.teams_voice_management.teams_auto_attendant.call_flow.button.transfer_to_ext_phone_number',
          destination: this.formatNumberFromApi(btn.destination) ?? '',
          icon: ZiroIcons.PHONE_OUTLINE,
        };
      case AutoAttendantButtonAction.ANNOUNCEMENT_AUDIO_FILE:
      case AutoAttendantButtonAction.ANNOUNCEMENT_TTS:
        return {
          label: 'tkey;admin.teams_voice_management.teams_auto_attendant.call_flow.button.transfer_to_announcement',
          subLabel: 'tkey;admin.teams_voice_management.teams_auto_attendant.call_flow.button.announcement.sub_text',
          destination: btn.destination ?? '',
          icon: ZiroIcons.ANNOUNCEMENTS,
        };
      case AutoAttendantButtonAction.NOT_SUPPORTED:
        return {
          label: 'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.destination.buttons.do_nothing',
          destination: '',
          icon: ZiroIcons.DISABLED,
        };
      default:
        return {
          label: btn.action ?? '',
          destination: btn.destination ?? '',
          icon: '',
        };
    }
  }

  formatNumberFromApi(number?: string | null): string {
    if (!number) {
      return '';
    }
    return number
      .replace(/^tel:/, '')
      .replace(/[()\-\s]/g, '')
      .trim();
  }

  formatNumberToApi(destinationNumber?: string | ZiroSelectOption | null): string {
    const destination = typeof destinationNumber === 'string' ? destinationNumber : destinationNumber?.value;
    if (!destination) {
      return '';
    }
    return `tel:${destination.replace(/[()\-\s]/g, '').trim()}`;
  }
}
